import { NavigationServiceConfiguration, PageDefinition } from "@cervval.js/client-html5-spa/navigation";
import { ObjectTools } from "@cervval.js/common/tools";

/**
 * Map of the pages of the application by pageName
 */
const pages = {
    "login": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("../pages/login/login.page").then((module) => new module.LoginPage()); }
    })
};

export type PageName = keyof typeof pages;

/**
 * @returns the navigation service configuration
 */
export function getNavigationServiceConfiguration(): NavigationServiceConfiguration<PageName> {
    const conf: NavigationServiceConfiguration<PageName> = {
        pages,
        defaultPage: "login"
    };
    return conf;
}